import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SellPageLinks } from '../NavItems/SellPageLinks';
import { LoginLink } from '../NavItems/LoginLink';
export var UnsubscribedUserNav = function UnsubscribedUserNav(_ref) {
  var isLivePage = _ref.isLivePage,
      isGoPage = _ref.isGoPage,
      isLoggedIn = _ref.isLoggedIn,
      isSearchPage = _ref.isSearchPage,
      isVenueDetailPage = _ref.isVenueDetailPage;
  return React.createElement(Fragment, null, !isLivePage && !isGoPage && React.createElement(SellPageLinks, {
    isSearchPage: isSearchPage,
    isVenueDetailPage: isVenueDetailPage
  }), !isLoggedIn && !isGoPage && React.createElement(LoginLink, null));
};
UnsubscribedUserNav.propTypes = {
  isLoggedIn: PropTypes.bool,
  isLivePage: PropTypes.bool,
  isGoPage: PropTypes.bool,
  isSearchPage: PropTypes.bool,
  isVenueDetailPage: PropTypes.bool
};